module.exports = __webpack_public_path__ + "static/media/zebra06.24450556.png";